/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Invite_Code_RequiredInputs */

const en_admin_settings_fields_invite_code_required = /** @type {(inputs: Admin_Settings_Fields_Invite_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Require invite code on sign up`)
};

/**
* | output |
* | --- |
* | "Require invite code on sign up" |
*
* @param {Admin_Settings_Fields_Invite_Code_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_invite_code_required = /** @type {((inputs?: Admin_Settings_Fields_Invite_Code_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Invite_Code_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_invite_code_required(inputs)
});
export { admin_settings_fields_invite_code_required as "admin.settings.fields.invite_code_required" }